import { createReduxAsyncThunk } from 'shared/utils';

import { driversAPI } from '../../api';

import { DRIVERS_STATE } from '../../constants';

export const getDriverFuelAssignmentsCards = createReduxAsyncThunk(
  `${DRIVERS_STATE}/getDriverFuelAssignmentsCards`,
  async () => {
    const { data } = await driversAPI.getDriverFuelAssignmentsCards();
    return data;
  }
);
